const OnlineOrder = {
    pendingOrder: () => "store/e-com/orders",
    updatedOnlineOrder:(id:string)=>`store/e-com/orders/${id}`,
    downloadOnlineOrder:(id:string)=>`store/e-com/download-receipt/${id}`,
}

export default OnlineOrder